import { getNodeByFlag } from "../../common/controlBar/controlBarDialog/metaComponent/utils"
import { washProductListItem } from '@/utils/wash.js'
import { washDataArabic, washDataArabicAlign, ArabicEach } from '@/mm/utils.js'

export function washData_listNews(walkedNode) {
  if (walkedNode._type === 'list_news1') {
    if (
      walkedNode.list &&
      walkedNode.list[1] &&
      walkedNode.list[1].list &&
      walkedNode.list[1].list[4] &&
      walkedNode.list[1].list[4].componentName === 'button_text'
    ) {
      var buttonNode = walkedNode.list[1].list[4]
      buttonNode.actions = [
        {
          "name": "design",
          "groupLayout": "topBottom",
          "config": {
            "文字设计": [
              "self_fontFamily",
              "self_textTheme",
              "self_fontSize",
              "self_color",
              "self_textStyle",
              "self_textAlign",
              "self_textInput"
            ],
            "按钮设计": [
              "self_width",
              "self_background",
              "self_border",
              "self_margin",
              "self_padding",
              "self_transverseMargin",
              "self_borderRadius",
              "self_shadow"
            ]
          }
        },
        "hover",
        "translate"
      ]
      buttonNode.flag = 'listItem_button'
    let ArabicRuleItem1 = [
      {
        flag: 'name',
        dataType: ['design','design'],
        onlyEnglish: ['title_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight']
      },
      {
        flag: 'abstract',
        dataType: ['design','design'],
        onlyEnglish: ['title_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight']
      }
    ]
    let item1 = getNodeByFlag(walkedNode, 'item1')
    ArabicEach(item1,ArabicRuleItem1)
    let ArabicRuleItem2 = [
      {
        flag: 'name',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right']
      },
      {
        flag: 'abstract',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right']
      },
      {
        flag: 'listItem_button',
        dataType: ['design'],
        onlyEnglish: [false],
        englishTitleLeft: ['self_marginLeft'],
        englishTitleRight: ['self_marginRight']
      }
    ]
    let item2 = getNodeByFlag(walkedNode, 'item2')
    ArabicEach(item2,ArabicRuleItem2)
    }
  }
  else if (walkedNode._type === 'list_news2') {

    if (
      walkedNode.list &&
      walkedNode.list[0] &&
      walkedNode.list[0].list &&
      walkedNode.list[0].list[1] &&
      walkedNode.list[0].list[1].list &&
      walkedNode.list[0].list[1].list[0].list &&
      walkedNode.list[0].list[1].list[0].list[0] &&
      walkedNode.list[0].list[1].list[0].list[0].list &&
      walkedNode.list[0].list[1].list[0].list[0].list[0] &&
      walkedNode.list[0].list[1].list[0].list[0].list[0].componentName === 'button_text_icon'
    ) {
      var buttonNode = walkedNode.list[0].list[1].list[0].list[0].list[0]
      buttonNode.flag = 'listItem_button'
      buttonNode.actions = [
        'design',
        'hover',
        "translate"
      ]
    }

    let ArabicRule = [
      {
        flag: 'create_date',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'name',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'abstract',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      }
    ]
    ArabicEach(walkedNode,ArabicRule)
  }
  else if (walkedNode._type === 'list_news3') {

    if (
      walkedNode.list &&
      walkedNode.list[0] &&
      walkedNode.list[0].list &&
      walkedNode.list[0].list[1] &&
      walkedNode.list[0].list[1].list &&
      walkedNode.list[0].list[1].list[3].list &&
      walkedNode.list[0].list[1].list[3].list[0] &&
      walkedNode.list[0].list[1].list[3].list[0].componentName === 'button_text_icon'
    ) {
      var buttonNode = walkedNode.list[0].list[1].list[3].list[0]
      buttonNode.actions = [
        {
          "name": "design",
          "groupLayout": "topBottom",
          "config": {
            "文字设计": [
              "self_fontFamily",
              "self_textTheme",
              "self_fontSize",
              "self_color",
              "self_textStyle",
              "self_textAlign",
              "self_textInput"
            ],
            "按钮设计": [
              "self_width",
              "self_background",
              "self_border",
              "self_margin",
              "self_padding",
              "self_transverseMargin",
              "self_borderRadius",
              "self_shadow"
            ]
          }
        },
        "hover",
        "translate"
      ]
    }
    let ArabicRule = [
      {
        flag: 'create_date_icon',
        dataType: ['design'],
        onlyEnglish: [false],
        englishTitleLeft: ['self_marginLeft'],
        englishTitleRight: ['self_marginRight'],
      },
      {
        flag: 'create_date',
        dataType: ['design','design'],
        onlyEnglish: ['title_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight'],
      },
      {
        flag: 'name',
        dataType: ['design','design'],
        onlyEnglish: ['title_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight'],
      },
      {
        flag: 'abstract',
        dataType: ['design','design'],
        onlyEnglish: [false, 'title_textAlign'],
        englishTitleLeft: ['self_marginLeft', 'left'],
        englishTitleRight: ['self_marginRight', 'right']
      },
      {
        flag: 'more',
        dataType: ['design','design'],
        onlyEnglish:[false,'self_flexAlign'],
        englishTitleLeft: ['self_marginLeft', 'left'],
        englishTitleRight: ['self_marginRight', 'right']
      }
    ]
    ArabicEach(walkedNode,ArabicRule)

  }
  else if (walkedNode._type === 'list_news4') {
    if (
      walkedNode.list &&
      walkedNode.list[0] &&
      walkedNode.list[0].list &&
      walkedNode.list[0].list[4] &&
      walkedNode.list[0].list[4].componentName === 'button_text'
    ) {
      var buttonNode = walkedNode.list[0].list[4]
      buttonNode.flag = 'listItem_button'
      buttonNode.actions = [
        {
          name: 'design',
          groupLayout: 'topBottom',
          config: {
            文字设计: [
              'self_textInput',
              'self_fontFamily',
              'self_textTheme',
              'self_fontSize',
              'self_color',
              'self_textStyle',
              'self_textAlign'
            ],
            按钮设计: [
              'self_background',
              'self_border',
              'self_margin',
              'self_padding',
              'self_transverseMargin',
              'self_borderRadius',
              'self_shadow'
            ]
          }
        },
        'hover',
        'translate'
      ]
    }
    washProductListItem(walkedNode, 'item')
    getNodeByFlag(walkedNode,'abstract').forceShowEye = true
    getNodeByFlag(walkedNode,'listItem_button').forceShowEye = true
    let ArabicRule = [
      {
        flag: 'name',
        dataType: 'design',
        onlyEnglish: 'title_textAlign',
        englishTitleLeft: 'left',
        englishTitleRight: 'right',
      },
      {
        flag: 'abstract',
        dataType: 'design',
        onlyEnglish: 'title_textAlign',
        englishTitleLeft: 'left',
        englishTitleRight: 'right',
      },
      {
        flag: 'create_date',
        dataType: 'design',
        englishTitleLeft: 'self_marginLeft',
        englishTitleRight: 'self_marginRight',
      },
    ]
    ArabicRule.forEach(item => {
      if (item.onlyEnglish) {
        washDataArabicAlign(walkedNode, item.flag, item.dataType, item.onlyEnglish, item.englishTitleLeft, item.englishTitleRight)
      } else {
        washDataArabic(walkedNode, item.flag, item.dataType, item.englishTitleLeft, item.englishTitleRight)
      }
    })

  }
  else if(walkedNode._type === 'list_news5'){
    if(
        walkedNode.list &&
        walkedNode.list[0] &&
        walkedNode.list[0].list &&
        walkedNode.list[0].list[4] &&
        walkedNode.list[0].list[4].list &&
        walkedNode.list[0].list[4].list[0] &&
        walkedNode.list[0].list[4].list[0].list &&
        walkedNode.list[0].list[4].list[0].list[0]&&
        walkedNode.list[0].list[4].list[0].list[0].componentName=='button_icon'
    ){
      var buttonNode = walkedNode.list[0].list[4].list[0].list[0]
      buttonNode.flag='listItem_button'
      console.log(buttonNode,'buttonNode');

    }

    let ArabicRule = [
      {
        flag: 'name',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'abstract',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'create-icon-box',
        dataType: ['design'],
        onlyEnglish: [false],
        englishTitleLeft: ['self_paddingLeft'],
        englishTitleRight: ['self_paddingRight'],
      },
      {
        flag: 'create_date',
        dataType: ['design','design'],
        onlyEnglish: [false, 'title_textAlign'],
        englishTitleLeft: ['self_paddingLeft', 'left'],
        englishTitleRight: ['self_paddingRight', 'right']
      }
    ]
    ArabicEach(walkedNode,ArabicRule)
  }
  else if (walkedNode._type === 'list_news6') {
    var buttonNode = getNodeByFlag(walkedNode, 'item').list[1].list[0]
    buttonNode.flag = 'listItem_button'

    let ArabicRule = [
      {
        flag: 'name',
        dataType: ['design','design'],
        onlyEnglish: ['title_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight'],
      },
      {
        flag: 'time_icon',
        dataType: ['design'],
        onlyEnglish: [false],
        englishTitleLeft: 'self_marginLeft',
        englishTitleRight: 'self_marginRight',
      },
      {
        flag: 'listItem_button',
        dataType: ['design'],
        onlyEnglish: [false],
        englishTitleLeft: 'self_marginLeft',
        englishTitleRight: 'self_marginRight',
      },
      {
        flag: 'abstract',
        dataType: ['design','design'],
        onlyEnglish: ['title_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight'],
      },
      {
        flag: 'create_date',
        dataType: ['design','design'],
        onlyEnglish: ['title_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight'],
      }
    ]
    ArabicEach(walkedNode,ArabicRule)
  }
  else if (walkedNode._type === 'list_news_style1') {
    let ArabicRule = [
      {
        flag: 'news_list_date',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left',],
        englishTitleRight: ['right'],
      },
      {
        flag: 'news_list_title',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left',],
        englishTitleRight: ['right'],
      },
      {
        flag: 'news_list_abstract',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left',],
        englishTitleRight: ['right'],
      },
      {
        flag: 'divider_flag',
        dataType: ['design'],
        onlyEnglish: [false],
        englishTitleLeft: ['self_marginLeft'],
        englishTitleRight: ['self_marginRight'],
      }
    ]
    ArabicEach(walkedNode,ArabicRule)
  }
}
